import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import {
  Button,
  Modal,
  Form
} from 'react-bootstrap';
import RedIconSVG from '../SVG/RedIconSVG';;
import CloseIcon from '../SVG/CloseIcon';
import { postRequest } from '../../helpers/apiHandler';
import CreatableSelect from 'react-select/creatable';
import { reloadContactList, reloadContactOverview } from '../../store/actions/reduxAction';

const ContactRemoveTags = (props) => {
  const { modalRemoveTagsShow, setRemoveTagsShow, allTags, selectedRows, selectedRowTags, access_token, reloadContactList, reloadContactOverview } = props;

  const [tagOptions, setTagOptions] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);

  useEffect(() => {
    if (modalRemoveTagsShow === true) {
      setTagOptions(selectedRowTags);
      setSelectedTags(selectedRowTags.map(tag => ({ value: tag, label: tag })))
    }
  }, [modalRemoveTagsShow]);

  const handleModalClose = () => {
    setRemoveTagsShow(false);
  };

  const handleSave = () => {

    const tags = selectedTags?.map(tag => tag.value);
    const data = {
      contacts: selectedRows,
      tags: tags || [],
    };

    postRequest(`/v2/contacts-remove-tags`, data, access_token.token, (res) => {
      if (res.success) {
        // Handle success if needed
        handleModalClose(true)
        reloadContactList();
        reloadContactOverview();
      }
    });
  };

  return (
    <>
      <Modal
        show={modalRemoveTagsShow}
        animation={true}
        onHide={handleModalClose}
        className="modal-form-contact"
        centered
      >
        <Modal.Body>
          <CloseIcon handleModalClose={handleModalClose} />
          <RedIconSVG />
          <Modal.Title as="h4" style={{ margin: '8px 0 16px' }}>
            Remove Tags
          </Modal.Title>
          <p>Please enter one or more tags to be removed from the selected contact(s)</p>
          <Form>
            <Form.Group>
              <Form.Label>Remove Tag(s)</Form.Label>
              <CreatableSelect
                options={tagOptions.map(tag => ({ value: tag, label: tag }))}
                isMulti
                value={selectedTags}
                onChange={setSelectedTags}
              />
            </Form.Group>
            <br></br>
            <Form.Group>
              <Button variant="primary" style={{ minWidth: 160 }} onClick={handleSave}>
                Remove Tags
              </Button>
            </Form.Group>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
};
const mapStateToProps = state => {
  const { access_token, user } = state.auth;

  return {
    access_token,
    user,
  };
};

const mapDispatchToProps = dispatch => ({
  reloadContactList: () => dispatch(reloadContactList()),
  reloadContactOverview: () => dispatch(reloadContactOverview())
});

export default connect(mapStateToProps, mapDispatchToProps)(ContactRemoveTags);
